import { Badge } from '@/components/ui/badge';

import { TotemLabel } from './TotemLabel';

export const CommonStatusTag = ({
    label,
    sublabel,
    backgroundColor,
    marginTop = null,
    labelColor,
    showHeading = false,
}: {
    label: string;
    sublabel?: string;
    backgroundColor: string;
    labelColor: string;
    marginTop?: string | null;
    showHeading?: boolean;
}) => {
    return (
        <div className="inline-flex flex-col items-start">
            {showHeading ? <TotemLabel className={sublabel ? 'mb-0' : 'mb-1.5'}>Statut</TotemLabel> : null}
            {sublabel ? <span className="mb-1.5 text-muted-foreground text-[13px]">{sublabel}</span> : null}
            <Badge
                className="rounded-full px-4 py-1 text-sm font-medium border-0"
                style={{
                    backgroundColor: `${backgroundColor}dd`,
                    color: labelColor,
                    ...(marginTop ? { marginTop } : {}),
                }}
            >
                {label}
            </Badge>
        </div>
    );
};
